import styled from "styled-components";

export const ContainerDadosResumo = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
`;